import { createContext, useEffect, useState } from "react";
import { api } from "../services/api";

export const userToken = () => window.localStorage.getItem("@app/token");
export const AuthContext = createContext({});
export function AuthContextProvider(props) {
  const [user, setUser] = useState();
  const isAuthenticated = () => userToken() !== null;
  const [errors, setErrors] = useState({});

  async function getUserInfo() {
    if (isAuthenticated()) {
      try {
        const response = await api.get("/api/v1/users/me", {
          headers: {
            Authorization: `Bearer ${userToken()}`,
            uid: window.localStorage.getItem("@app/uid"),
            client: window.localStorage.getItem("@app/client"),
            "access-token": window.localStorage.getItem("@app/token"),
            "Cross-Origin-Opener-Policy": "same-origin-allow-popups",
          }
        });
        const user = response.data;
        setUser(user);
        localStorage.setItem("userPhoto", response.data.user_photo)
        localStorage.setItem("userId", response.data.id)
        return user;
      } catch {
        signOutUser();
      }
    }
  }

  useEffect(() => {
    getUserInfo();
  }, []);

  async function signInUser(email, password) {
    try {
      const response = await api.post("/api/v1/auth/sign_in", { email, password });
      window.localStorage.setItem("@app/token", response.headers["access-token"]);
      window.localStorage.setItem("@app/uid", response.headers["uid"]);
      window.localStorage.setItem("@app/client", response.headers["client"]);
      window.localStorage.setItem("@app/expiry", response.headers["expiry"]);
      const currentUser = await getUserInfo();
      const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
      if (guestCart.length > 0 && currentUser) {
        await transferGuestCartToUser(guestCart, currentUser);
        localStorage.removeItem("guestCart");
      }
      window.location.href = "/carrinho";
      return true;
    } catch {
      return false;
    }
  }

  async function signUpUser(email, password, full_name, document_number, phone_number) {
    const requestBody = { email, password, full_name, document_number, phone_number };
    const signupOrigin = localStorage.getItem("signup_origin");
    try {
      const response = await api.post("/api/v1/auth", requestBody);
      window.localStorage.setItem("@app/token", response.headers["access-token"]);
      window.localStorage.setItem("@app/uid", response.headers["uid"]);
      window.localStorage.setItem("@app/client", response.headers["client"]);
      window.localStorage.setItem("@app/expiry", response.headers["expiry"]);
      await getUserInfo();
      localStorage.removeItem("signup_origin");
      if (typeof window !== "undefined" && window.fbq) {
        window.fbq('trackCustom', 'signUpUser');
      }
      if (signupOrigin !== "checkout") {
        window.location.href = "/";
      }
      return true;
    } catch (e) {
      if (e.response?.data?.errors) {
        setErrors(e.response.data.errors);
      }
      return false;
    }
  }

  async function transferGuestCartToUser(guestCart, targetUser) {
    const promises = guestCart.map(async (cartBatch) => {
      const dataObject = new FormData();
      dataObject.append('cart_batch[amount]', cartBatch.amount);
      dataObject.append('cart_batch[quantity]', cartBatch.quantity);
      dataObject.append('cart_batch[user_id]', targetUser.id);
      dataObject.append('cart_batch[batch_id]', cartBatch.batch_id);
      const response = await api.post(`/api/v1/cart_batches`, dataObject);
      return response;
    });

    return Promise.all(promises).then((responses) => {
      if (responses.every((response) => response.data.status === 'created')) {
        return {
          success: true,
        };
      } else {
        return {
          success: false,
          message: 'Algo deu errado',
        };
      }
    });
  }


  async function signOutUser() {
    setUser(null);
    window.localStorage.removeItem("@app/token");
    window.localStorage.removeItem("@app/uid");
    window.localStorage.removeItem("@app/client");
    window.localStorage.removeItem("@app/expiry");
    localStorage.removeItem('userId');
    window.location = "/"
  }

  return (
    <AuthContext.Provider
      value={{ user, signInUser, isAuthenticated, signOutUser, signUpUser, setUser, getUserInfo, errors, setErrors }}
    >
      {props.children}
    </AuthContext.Provider>
  );
}
